import React from 'react';
import './cvizRadioGroup.scss';

const CvizRadioGroup = (props) => {
  return (
    <>
      <h4>{props.radioHeader}</h4>
      <div className="ontario-radios">
        <fieldset
          onChange={(e) => {
            let res = e.target.value;
            if (res === 'true') {
              res = true;
            } else if (res === 'false') {
              res = false;
            }
            props.onChange(res);
          }}
          value={props.value}
        >
          {props.cases.map((n, i) => (
            <div
              className={`ontario-radios__item ${props.className}`}
              key={i}
            >
              <input
                className="ontario-radios__input"
                id={
                  'cviz_radio-button-option' + props.optionsName + i
                }
                name={'radiobutton_group' + props.optionsName}
                defaultChecked={i === 0}
                type="radio"
                value={n[0]}
                key={i}
              />
              <label
                className={`ontario-label ontario-radios__label ${props.className}`}
                htmlFor={
                  'cviz_radio-button-option' + props.optionsName + i
                }
              >
                {n[1]}
              </label>
            </div>
          ))}
        </fieldset>
      </div>
    </>
  );
};

export default CvizRadioGroup;
